/* ============================================================
   BB Offer-Picker — Port von Starkfeld sf-buybox.js (<sf-offer-picker>).
   BebeLux-Anbindung: liest Varianten aus embedded JSON + input[name="id"],
   komponiert bb_items (ID:QTY), setzt bb_discount + gift(bundles).
   Direct-Checkout-Interceptor baut /cart/ID:QTY?discount=CODE.
   ============================================================ */
(function () {
  function formatMoney(cents) {
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  if (!customElements.get('bb-offer-picker')) {
    customElements.define('bb-offer-picker', class extends HTMLElement {
      connectedCallback() {
        this.formId = this.getAttribute('form');
        this.unitPrice = parseInt(this.getAttribute('data-unit-price'), 10) || 0;
        this.unitCompare = parseInt(this.getAttribute('data-unit-compare'), 10) || 0;
        this.colorName = this.getAttribute('data-color-name') || 'Farbe';
        try { this.variants = JSON.parse(this.querySelector('[data-bb-offer-variants]').textContent); }
        catch (e) { this.variants = []; }
        this.byId = {};
        this.variants.forEach(function (v) { this.byId[String(v.id)] = v; }, this);

        this.onChange = this.onChange.bind(this);
        this.onClick = this.onClick.bind(this);
        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onClick);
        this.form = document.getElementById(this.formId);

        var idInput = this.idInput;
        if (idInput) {
          this._obs = new MutationObserver(this.onVariantChange.bind(this));
          this._obs.observe(idInput, { attributes: true, attributeFilter: ['value'] });
        }
        // theme fires change on variant radios; recompute shortly after
        (this.form || document).addEventListener('change', function () {
          setTimeout(this.onVariantChange.bind(this), 60);
        }.bind(this));

        this.updateAvailability();
        this.initializeUnitRows();
        this.renderPrices();
        this.syncForm();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('click', this.onClick);
        if (this._obs) this._obs.disconnect();
      }

      get selectedTier() { return this.querySelector('input[name^="bb-offer"]:checked'); }
      get qtyInput() { return document.querySelector('input[name="quantity"][data-bb-offer-qty][form="' + this.formId + '"]'); }
      get itemsInput() { return document.querySelector('input[name="bb_items"][data-bb-offer-items][form="' + this.formId + '"]'); }
      get giftInput() { return document.querySelector('input[name="bundles"][data-bb-offer-gift][form="' + this.formId + '"]'); }
      get discountInput() { return document.querySelector('input[name="bb_discount"][form="' + this.formId + '"]'); }
      get idInput() { return (this.form || document).querySelector('input[name="id"]'); }
      get mainVariantId() { var el = this.idInput; return el ? el.value : null; }

      currentVariant() {
        var id = String(this.mainVariantId || '');
        return this.byId[id] || this.variants[0] || { color: '', set: null };
      }
      currentSet() { return this.currentVariant().set; }
      findVariant(color, set) {
        for (var i = 0; i < this.variants.length; i++) {
          var v = this.variants[i];
          if (v.color === color && (set == null || v.set === set)) return v;
        }
        return null;
      }

      /* set the main product variant by clicking the theme's color radio */
      selectMainColor(color) {
        var sx = window.scrollX, sy = window.scrollY;
        var radios = document.querySelectorAll('input[type="radio"][form="' + this.formId + '"][name^="' + this.colorName + '-"]');
        for (var i = 0; i < radios.length; i++) {
          if ((radios[i].value === color) && !radios[i].classList.contains('disabled')) {
            if (!radios[i].checked) { radios[i].click(); }
            break;
          }
        }
        window.scrollTo(sx, sy);
        this.syncMainColorButtons(color);
      }

      updateAvailability() {
        var set = this.currentSet();
        var self = this;
        this.querySelectorAll('[data-bb-unit-button]').forEach(function (btn) {
          var v = self.findVariant(btn.getAttribute('data-color'), set);
          btn.setAttribute('data-bb-variant-id', v ? v.id : '');
          btn.disabled = !v || !v.available;
        });
      }

      initializeUnitRows() {
        var mainColor = this.currentVariant().color;
        var self = this;
        this.querySelectorAll('[data-bb-unit-row]').forEach(function (row) {
          var btn = self.findColorButton(row, mainColor) || row.querySelector('[data-bb-unit-button]:not([disabled])') || row.querySelector('[data-bb-unit-button]');
          if (btn) self.selectUnitButton(btn, { silent: true });
        });
        this.composeItems();
      }

      findColorButton(row, color) {
        var b = row ? row.querySelectorAll('[data-bb-unit-button]') : [];
        for (var i = 0; i < b.length; i++) if (b[i].getAttribute('data-color') === color) return b[i];
        return null;
      }

      selectUnitButton(button, opts) {
        opts = opts || {};
        var row = button.closest('[data-bb-unit-row]');
        if (!row || button.disabled) return;
        var color = button.getAttribute('data-color') || '';
        row.setAttribute('data-bb-variant-id', button.getAttribute('data-bb-variant-id') || '');
        row.setAttribute('data-bb-color', color);
        if (opts.touched) row.setAttribute('data-bb-touched', 'true');
        row.querySelectorAll('[data-bb-unit-button]').forEach(function (b) {
          var on = b === button;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        var unit = row.getAttribute('data-bb-unit-row');
        var label = row.querySelector('[data-bb-unit-color="' + unit + '"]');
        if (label) label.textContent = color;
        if (!opts.silent) this.composeItems();
      }

      syncMainColorButtons(color) {
        var self = this;
        this.querySelectorAll('[data-bb-unit-row="1"]').forEach(function (row) {
          var m = self.findColorButton(row, color);
          if (m) self.selectUnitButton(m, { silent: true });
        });
      }

      onClick(e) {
        var button = e.target.closest('[data-bb-unit-button]');
        if (!button || !this.contains(button)) return;
        e.preventDefault();
        if (button.disabled) return;
        var row = button.closest('[data-bb-unit-row]');
        var unit = row ? parseInt(row.getAttribute('data-bb-unit-row'), 10) || 1 : 1;
        if (unit === 1 || button.hasAttribute('data-bb-main-color')) { this.selectMainColor(button.getAttribute('data-color')); return; }
        this.selectUnitButton(button, { touched: true });
      }

      onChange(e) {
        if ((e.target.name || '').indexOf('bb-offer') === 0) this.syncForm();
      }

      onVariantChange() {
        var v = this.currentVariant();
        this.unitPrice = (typeof v.price === 'number') ? v.price : this.unitPrice;
        this.unitCompare = v.compare_at_price || 0;
        this.updateAvailability();
        this.followMainColor(v.color);
        this.renderPrices();
        this.composeItems();
      }

      /* untouched units follow the main color; explicit picks stay */
      followMainColor(color) {
        if (!color) return;
        var self = this;
        this.syncMainColorButtons(color);
        this.querySelectorAll('[data-bb-unit-row]').forEach(function (row) {
          var unit = parseInt(row.getAttribute('data-bb-unit-row'), 10) || 1;
          if (unit === 1 || row.getAttribute('data-bb-touched') === 'true') return;
          var m = self.findColorButton(row, color);
          if (m && !m.disabled) self.selectUnitButton(m, { silent: true });
        });
      }

      composeItems() {
        var itemsInput = this.itemsInput;
        if (!itemsInput) return;
        var tier = this.selectedTier;
        var qty = tier ? parseInt(tier.getAttribute('data-qty'), 10) || 1 : 1;
        var mainId = this.mainVariantId;
        if (qty <= 1 || !mainId) { itemsInput.value = ''; return; }
        var counts = {}; counts[mainId] = 1;
        var wrap = tier.closest('.bbo-offer');
        var rows = wrap ? wrap.querySelectorAll('[data-bb-unit-row]') : [];
        for (var i = 0; i < rows.length; i++) {
          var unit = parseInt(rows[i].getAttribute('data-bb-unit-row'), 10) || 1;
          if (unit <= 1 || unit > qty) continue;
          var id = rows[i].getAttribute('data-bb-variant-id');
          if (!id) continue;
          counts[id] = (counts[id] || 0) + 1;
        }
        var total = Object.keys(counts).reduce(function (s, k) { return s + counts[k]; }, 0);
        if (total < qty) counts[mainId] += qty - total;
        itemsInput.value = Object.keys(counts).map(function (id) { return id + ':' + counts[id]; }).join(',');
      }

      syncForm() {
        var tier = this.selectedTier;
        if (!tier) return;
        var qty = parseInt(tier.getAttribute('data-qty'), 10) || 1;
        var code = tier.getAttribute('data-code') || '';
        var hasGift = tier.getAttribute('data-gift') === 'true';
        var qtyInput = this.qtyInput;
        if (qtyInput && qtyInput.value !== String(qty)) { qtyInput.value = qty; }
        var giftInput = this.giftInput; if (giftInput) giftInput.checked = hasGift;
        var discountInput = this.discountInput; if (discountInput) discountInput.value = code;
        // toggle unit rows visibility per selected qty
        var self = this;
        this.querySelectorAll('.bbo-offer').forEach(function (offer) {
          var input = offer.querySelector('input[name^="bb-offer"]');
          var box = offer.querySelector('[data-bb-units]');
          if (!box) return;
          var active = input && input.checked;
          box.hidden = !active;
          var oqty = input ? parseInt(input.getAttribute('data-qty'), 10) || 1 : 1;
          offer.querySelectorAll('[data-bb-unit-row]').forEach(function (row) {
            var u = parseInt(row.getAttribute('data-bb-unit-row'), 10) || 1;
            row.hidden = u > oqty;
          });
        });
        this.composeItems();
      }

      renderPrices() {
        var self = this;
        this.querySelectorAll('.bbo-offer').forEach(function (offer) {
          var input = offer.querySelector('input[name^="bb-offer"]');
          if (!input) return;
          var qty = parseInt(input.getAttribute('data-qty'), 10) || 1;
          var pct = parseFloat(input.getAttribute('data-discount')) || 0;
          // Shopify product discounts truncate the discount per unit to cents.
          var unitDiscount = Math.floor(self.unitPrice * pct / 100);
          var now = (self.unitPrice - unitDiscount) * qty;
          // Streichpreis = Menge x Vergleichspreis (compare_at, falls hoeher, sonst Preis).
          var onSale = self.unitCompare > self.unitPrice;
          var was = (onSale ? self.unitCompare : self.unitPrice) * qty;
          var nowEl = offer.querySelector('[data-price-now]');
          var wasEl = offer.querySelector('[data-price-was]');
          var unitEl = offer.querySelector('[data-price-unit]');
          var saveEl = offer.querySelector('[data-price-save]');
          if (nowEl) nowEl.textContent = formatMoney(now);
          if (wasEl) {
            if (was > now) { wasEl.textContent = formatMoney(was); wasEl.hidden = false; }
            else wasEl.hidden = true;
          }
          // Label: waehrend einer Preisaktion die Gesamtersparnis gegen den
          // Streichpreis (abgerundet), sonst der Mengenrabatt des Blocks.
          if (saveEl && pct > 0) {
            var shown = (onSale && was > now) ? Math.floor((was - now) * 100 / was) : pct;
            saveEl.textContent = '\u2212' + shown + '%';
          }
          if (unitEl && qty > 1) { unitEl.textContent = formatMoney(Math.round(now / qty)) + ' ' + (unitEl.getAttribute('data-unit-label') || ''); unitEl.hidden = false; }
          else if (unitEl) unitEl.hidden = true;
        });
      }
    });
  }

  /* ----------------------------------------------------------
     Direct-Checkout-Interceptor (Port aus buy-buttons.liquid).
     Nur wenn bb_items ODER bb_discount gesetzt (Kaufe 2/3) — Kaufe 1
     laeuft ueber das native Add-to-Cart des Themes.
     ---------------------------------------------------------- */
  if (!window.__bbDirectCheckout) {
    window.__bbDirectCheckout = true;
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      if (form.querySelector('[name^="properties["]')) return;
      var fd = new FormData(form);
      var items = fd.get('bb_items');
      var discount = fd.get('bb_discount');
      if (!items && !discount) return; // single unit -> native add-to-cart
      var idInput = form.querySelector('[name="id"]');
      if (!idInput || !idInput.value) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var qty = parseInt(fd.get('quantity'), 10) || 1;
      if (!items) items = idInput.value + ':' + qty;
      var formId = form.getAttribute('id');
      var bundles = document.querySelectorAll('input[name="bundles"]:checked[form="' + formId + '"]');
      for (var i = 0; i < bundles.length; i++) { if (bundles[i].value) items += ',' + bundles[i].value + ':1'; }
      // Cart permalinks create a NEW cart and invalidate the signed consent
      // binding. Preserve the current cart identity using the Shopify Ajax API.
      if (form.__bbCheckoutInFlight) return;
      form.__bbCheckoutInFlight = true;
      var buttons = Array.prototype.slice.call(form.querySelectorAll('[type="submit"]'));
      var disabledBefore = buttons.map(function (button) { return button.disabled; });
      buttons.forEach(function (button) { button.disabled = true; });
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(root)) root = '/';

      function postCart(action, body) {
        return window.fetch(root + 'cart/' + action + '.js', {
          method: 'POST', credentials: 'same-origin', redirect: 'error',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify(body), signal: AbortSignal.timeout(10000)
        }).then(function (response) {
          if (!response.ok) throw new Error('cart_request_failed');
          return response.json();
        });
      }

      Promise.resolve().then(function () {
        var counts = Object.create(null);
        String(items).split(',').forEach(function (part) {
          var pair = /^([1-9][0-9]{0,15}):([1-9][0-9]{0,3})$/.exec(part);
          if (!pair || !Number.isSafeInteger(Number(pair[1]))) throw new Error('cart_items_invalid');
          counts[pair[1]] = (counts[pair[1]] || 0) + Number(pair[2]);
        });
        var cartItems = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
        if (!cartItems.length || cartItems.length > 250) throw new Error('cart_items_invalid');
        return postCart('clear', {}).then(function () { return postCart('add', { items: cartItems }); });
      }).then(function () {
        // Match the old permalink: this offer's code, or no retained old code.
        return postCart('update', { discount: typeof discount === 'string' ? discount : '' });
      }).then(function () {
        if (typeof window.bbOpenAIAdsPrepareCheckout !== 'function') return;
        // A tracking outage must not strand a customer's checkout.
        return new Promise(function (resolve) {
          var timer = window.setTimeout(resolve, 5000);
          Promise.resolve().then(function () { return window.bbOpenAIAdsPrepareCheckout(); })
            .catch(function () {}).then(function () { window.clearTimeout(timer); resolve(); });
        });
      }).then(function () {
        try {
          document.dispatchEvent(new CustomEvent('bb:direct-checkout', {
            detail: { items: items, cartAlreadyAdded: true }
          }));
        } catch (error) {}
        window.location.href = root + 'checkout';
      }).catch(function () {
        form.__bbCheckoutInFlight = false;
        buttons.forEach(function (button, index) { button.disabled = disabledBefore[index]; });
        // Shopify's cart page provides the existing localized recovery surface.
        window.location.href = root + 'cart';
      });
    }, true);
  }
})();
